import React from 'react';
import { FiMail, FiMapPin } from 'react-icons/fi';
import { COMPANY } from '../../siteData';
import {
  Section,
  SectionInner,
  SectionHeader,
  Eyebrow,
  SectionTitle,
  SectionLead,
} from '../ui/Section';
import {
  ContactGrid,
  ContactCard,
  ContactIcon,
  ContactLabel,
  ContactValue,
  ContactEmail,
} from './ContactElements';

const Contact = () => {
  return (
    <Section id='contact' tone='subtle'>
      <SectionInner>
        <SectionHeader>
          <Eyebrow>Contact</Eyebrow>
          <SectionTitle>Let’s talk</SectionTitle>
          <SectionLead>
            Have a project in mind or a question about one of our products? Reach
            out and we will get back to you.
          </SectionLead>
        </SectionHeader>
        <ContactGrid>
          <ContactCard>
            <ContactIcon>
              <FiMail />
            </ContactIcon>
            <ContactLabel>Email</ContactLabel>
            <ContactValue>
              <ContactEmail href={`mailto:${COMPANY.email}`}>
                {COMPANY.email}
              </ContactEmail>
            </ContactValue>
          </ContactCard>
          <ContactCard>
            <ContactIcon>
              <FiMapPin />
            </ContactIcon>
            <ContactLabel>Office</ContactLabel>
            <ContactValue>
              {COMPANY.legalName}
              <br />
              {COMPANY.addressLine}
              <br />
              {COMPANY.city}, {COMPANY.state} {COMPANY.zip}
              <br />
              {COMPANY.country}
            </ContactValue>
          </ContactCard>
        </ContactGrid>
      </SectionInner>
    </Section>
  );
};

export default Contact;
